import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useCommonSelector } from '../common/selector';
import { setCustomerCardStateAction } from '../common/commonActions';
import { CustomerCardState, CustomerCardOptions } from '@makemydeal/dr-sales-checkin-types';

/**
 * Custom hook to manage the state of the customer card component.
 * Provides the current state and a function to transition between states.
 */
export const useCustomerCardState = () => {
    const dispatch = useDispatch();
    const commonState = useCommonSelector();
    const state = commonState.customerCardState || CustomerCardState.CLOSE;
    const options = commonState.customerCardOptions;

    const transitionTo = (newState: CustomerCardState, newOptions?: CustomerCardOptions) => {
        dispatch(setCustomerCardStateAction(newState, newOptions));
    };

    const handleCloseSlider = useCallback(() => {
        dispatch(setCustomerCardStateAction(CustomerCardState.CLOSE));
    }, [dispatch]);

    return { state, options, transitionTo, handleCloseSlider };
};
